<template>
  <Modal ref="modal" title="Boletos Pagos">
    <form class="export-container" @submit.prevent="handleSubmit">
      <InputMonth legend="Insira a data" :modelValue="mes" @update:modelValue="$event => this.mes = $event"
        :disabled="loading" />

      <div class="format-container">
        <span>Em qual formato de exportação?</span>

        <RadioButtons :options="radioOptions" name="format" :modelValue="format"
          @update:modelValue="$event => this.format = $event" />
      </div>

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import InputMonth from 'core/InputMonth'
import RadioButtons from 'core/RadioButtons'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'BoletosPagosModal',
  components: {
    Modal,
    Button,
    InputMonth,
    RadioButtons,
    TrayArrowDown,
  },
  data() {
    return {
      mes: '',
      format: 'pdf',
      radioOptions: [
        { value: "pdf", label: "PDF", info: "(Documento)" },
        { value: "csv", label: "CSV", info: "(Planilha)" },
        { value: "txt", label: "TXT", info: "(Texto sem formatação)", disabled: true },
      ],
      loading: false,
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.mes = ''
      this.format = 'pdf'
      this.$refs.modal.close()
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        periodo: this.mes,
        tipo: this.format,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/faturamento/exportar/boletos-pagos`, {
        params,
      })
        .then((res) => {
          switch (this.format) {
            case 'pdf': {
              _export.downloadPDF(res.body, 'boletos-pagos')
              break
            }
            case 'csv': {
              _export.downloadCSV(res.body, 'boletos-pagos')
              break
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.toast(`Erro ao tentar gerar relatório: ${err.body.mensagem}`)
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (!this.mes) {
        this.toast('O campo de data é obrigatório.')
        return false
      }

      return true
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>